var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Hero'),_c('breadcrumbs',{attrs:{"crumbs":_vm.breadcrumbs}}),(_vm.article)?_c('div',[_c('div',{staticClass:"knowledge-article-heading"},[_vm._v(" "+_vm._s(_vm.article.title)+" ")]),_c('div',{staticClass:"knowledge-article-content",domProps:{"innerHTML":_vm._s(_vm.article.text)}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }